import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterChecklistComponent } from './components/filter-checklist/filter-checklist.component';
import { FilterOptionsComponent } from './components/filter-options/filter-options.component';
import { FilterSharedComponent } from './components/filter-shared/filter-shared.component';
import { ChecklistGroupModule } from '../checklist-group/checklist-group.module';
import { MatIconModule } from '@angular/material/icon';
import { PopoverModule } from '../popover/popover.module';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { InputBoxModule } from '../input-box/input-box.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterHierarchyComponent } from './components/filter-hierarchy/filter-hierarchy.component';
import { OrgTreeModule } from '../org-tree/org-tree.module';
import { SearchBarModule } from '../search-bar/search-bar.module';
import { DxFilterBuilderModule, DxScrollViewModule, DxSelectBoxModule, DxTagBoxModule } from 'devextreme-angular';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MainFilterComponent } from './components/main-filter/main-filter.component';
import { MatRippleModule } from '@angular/material/core';
import { FilterListTypeComponent } from './components/filter-list-type/filter-list-type.component';
import { CheckboxGroupModule } from '../checkbox-group/checkbox-group.module';
import { FilterTagComponent } from './components/filter-tag/filter-tag.component';
import { TagModule } from '../tag/tag.module';
import { FilterItemsChecklistComponent } from './components/filter-items-checklist/filter-items-checklist.component';
import { ButtonsModule } from '../buttons/buttons.module';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { FilterDateComponent } from './components/filter-date/filter-date.component';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { FilterBuilderComponent } from './components/filter-builder/filter-builder.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    FilterBuilderComponent,
    FilterChecklistComponent,
    FilterOptionsComponent,
    FilterSharedComponent,
    FilterHierarchyComponent,
    FilterListTypeComponent,
    FilterTagComponent,
    FilterItemsChecklistComponent,
    FilterDateComponent,
    MainFilterComponent,
  ],
  imports: [
    ButtonsModule,
    CheckboxGroupModule,
    ChecklistGroupModule,
    CommonModule,
    DxFilterBuilderModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTagBoxModule,
    DropdownsModule,
    FormFieldsModule,
    FormsModule,
    InputBoxModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatRippleModule,
    MatSlideToggleModule,
    OrgTreeModule,
    PopoverModule,
    ReactiveFormsModule,
    SearchBarModule,
    TagModule,
    TranslateModule,
    MatDividerModule,
  ],
  exports: [
    FilterChecklistComponent,
    FilterHierarchyComponent,
    MainFilterComponent,
    FilterItemsChecklistComponent,
    FilterDateComponent,
    FilterListTypeComponent,
    FilterTagComponent,
    FilterBuilderComponent,
  ],
})
export class FilterModule {}
